import { UserFormValue } from './UserFormValue'
import { ReadingStatus } from '../enums/ReadingStatus'
import { v4 as uuidv4 } from 'uuid'
import { UserFormWithTemplateName } from './UserFormWithTemplateName'
import { UserFormWithTemplateUserRecurrence } from './UserFormWithTemplateUserRecurrence'
import { UserFormWithTemplateUserRecurrenceDTO } from './UserFormDTO'

export interface UserFormWithTemplateNameDTO {
  id: string | undefined
  userID: string
  circleID: string
  formID: string
  userFormValues: UserFormValueDTO[]
  readingStatus: ReadingStatus
  typeForm: string
  templateName: string
}

export function emptyUserFormWithTemplateNameDTO(user: string, circle: string) {
  return {
    id: uuidv4(),
    userID: user,
    circleID: circle,
    formID: uuidv4(),
    userFormValues: [],
    readingStatus: ReadingStatus.Pending,
    typeForm: '',
    templateName: '',
  }
}

export interface UserFormValueDTO {
  userFormID: string
  formFieldID: string
  values?: string[]
  date: Date
  done: boolean
}

export function fromModel(m: UserFormWithTemplateName): UserFormWithTemplateNameDTO {
  return {
    id: m.id,
    userID: m.userID,
    circleID: m.circleID,
    formID: m.formID,
    userFormValues: m.userFormValues.map((v) => fromModelValue(v)),
    readingStatus: m.readingStatus,
    typeForm: m.typeForm,
    templateName: '',
  }
}

export function fromModelValue(v: UserFormValue): UserFormValueDTO {
  let values = v.getValues()
  let result: string[]
  if (values && !Array.isArray(values)) {
    if (typeof values === typeof false) {
      result = [values ? '1' : '0']
    } else {
      result = [values as unknown as string]
    }
  } else {
    result = Array.isArray(values) ? values : ['']
  }
  return {
    userFormID: v.userFormID,
    formFieldID: v.formFieldID,
    values: result,
    date: new Date(),
    done: v.done,
  }
}

export function toModel(d: UserFormWithTemplateNameDTO): UserFormWithTemplateName {
  return new UserFormWithTemplateName({
    id: d.id,
    userID: d.userID,
    circleID: d.circleID,
    formID: d.formID,
    userFormValues: d.userFormValues.map((v) => toModelValue(v)),
    readingStatus: d.readingStatus,
    typeForm: d.typeForm,
    templateName: d.templateName,
  })
}

export function toModelUserFormWithTemplateUserRecurrence(
  d: UserFormWithTemplateUserRecurrenceDTO
): UserFormWithTemplateUserRecurrence {
  return new UserFormWithTemplateUserRecurrence({
    id: d.id,
    userID: d.userID,
    circleID: d.circleID,
    formID: d.formID,
    userFormValues: d.userFormValues.map((v) => toModelValue(v)),
    readingStatus: d.readingStatus,
    templateUserRecurrence: d.templateUserRecurrence,
  })
}

export function toModelValue(v: UserFormValueDTO): UserFormValue {
  return new UserFormValue(v)
}
